import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss']
})
export class FilterButtonComponent {
  @Input() active: boolean = false;
  @Output() remove = new EventEmitter<any>();

  constructor() {  
  }

  onRemove() {
    this.remove.emit();
  }
}
